import { useUserConfig } from '../context/UserConfigContext';
import { TrainingSetItemStatusListMode } from '../shared/constants';

export function useTrainingSetItemStatusListMode(): TrainingSetItemStatusListMode {
  const { options } = useUserConfig();
  return options.trainingSetItemStatusListMode;
}
